/* eslint-disable react/no-array-index-key */
/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import get from 'lodash/get';

import { icons } from 'uikit/utils';

import styles from '../styles/uikitIconsIcon.module.scss';

const Icon = forwardRef(
  ({ ariaHidden = '', ariaLabel = '', className = '', icon, size = 24, testId = '' }, ref) => {
    if (!icon) return null;

    const svgData = get(icons, icon);

    if (!svgData) {
      console.warn(
        `Icon ${icon} not found, please check icons.js for your chosen icon and ensure that the correct data is there to render.`,
      );
      return null;
    }

    return (
      <svg
        aria-hidden={ariaHidden}
        aria-label={ariaLabel}
        className={classnames(styles.element, className)}
        data-testid={testId}
        height={size}
        ref={ref}
        viewBox={svgData.viewBox || '0 0 24 24'}
        width={size}
        xmlns="http://www.w3.org/2000/svg"
      >
        {svgData.element.map((svgElement, index) => {
          const Element = svgElement.type;
          const elementProps = svgElement.type === React.Fragment ? {} : { 'aria-hidden': true };

          return (
            <Element
              {...svgElement.props}
              {...elementProps}
              key={`icon-${icon}-element-${index}`}
            />
          );
        })}
      </svg>
    );
  },
);

Icon.propTypes = {
  ariaHidden: PropTypes.bool,
  ariaLabel: PropTypes.string,
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  testId: PropTypes.string,
};

export { Icon as IconStorybook };
export default React.memo(Icon);
